import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import DeleteIcon from "../../assets/checked1.png";

function DeleteModal({ deleteModal, staffName, yesClickHandler, noClickHandler }) {
  return (
    <Modal
      show={deleteModal}
      onHide={(e) => noClickHandler(e)}
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Body className="py-5 px-4">
        <img
          src={DeleteIcon}
          alt="check"
          className="mx-auto d-block"
          style={{ height: "77px", width: "77px" }}
        />
        <div className="text-center mt-2 staff-add-modal-head">
          Delete staff member
        </div>
        <div className="text-center my-2 staff-add-modal-bodyhead">
          Name: {staffName}
        </div>
        <div className="text-center my-2 staff-add-modal-body">
          Do you want to permanently delete this staff member?
        </div>
        <div className="text-center mt-3">
          <button
            className="staff-modal-enable-btn py-2 px-5 mr-2"
            onClick={(e) => yesClickHandler(e)}
          >
            Yes
          </button>
          <button
            className="staff-modal-disable-btn py-2 px-5 ml-2"
            onClick={(e) => noClickHandler(e)}
          >
            No
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;
